import { Colors } from '@/common/colors/colors';
import styled from 'styled-components';

export const Title = styled.h3`
	color: ${Colors.darkBlue};
	margin-bottom: 40px;
`;
